import PropTypes from 'prop-types';
import React from 'react';
import s from './WorkTracker.module.scss';
import { LISTS, SORT_OPTIONS } from './lib/sorting';
import { CalendarIcon, ListIcon, SearchIcon } from './icons';

const VIEWS = [
  { value: 'list', label: 'List view', icon: <ListIcon /> },
  { value: 'calendar', label: 'Calendar view', icon: <CalendarIcon /> },
];

export default function Toolbar({
  view, onView, list, onList, sort, onSort, search, onSearch, onNewTask,
}) {
  return (
    <div className={s.toolbar}>
      <div className={s.segment} role="group" aria-label="View">
        {VIEWS.map((o) => (
          <button
            type="button"
            key={o.value}
            className={s.iconBtn}
            aria-pressed={view === o.value}
            aria-label={o.label}
            title={o.label}
            onClick={() => onView(o.value)}
          >
            {o.icon}
          </button>
        ))}
      </div>
      <div className={s.segment} role="group" aria-label="Which tasks">
        {LISTS.map((o) => (
          <button type="button" key={o.value} aria-pressed={list === o.value} onClick={() => onList(o.value)}>
            {o.label}
          </button>
        ))}
      </div>
      <select className={s.select} value={sort} onChange={(e) => onSort(e.target.value)} aria-label="Sort">
        {SORT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{`Sort: ${o.label}`}</option>)}
      </select>
      <span className={s.searchWrap}>
        <SearchIcon className={s.searchIcon} />
        <input
          type="search"
          className={`${s.input} ${s.search}`}
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Search titles and descriptions"
          aria-label="Search tasks"
        />
      </span>
      <span className={s.spacer} />
      <button type="button" className={s.btnPrimary} onClick={onNewTask}>New Task</button>
    </div>
  );
}

Toolbar.propTypes = {
  view: PropTypes.oneOf(['list', 'calendar']).isRequired,
  onView: PropTypes.func.isRequired,
  list: PropTypes.oneOf(['active', 'complete']).isRequired,
  onList: PropTypes.func.isRequired,
  sort: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  onNewTask: PropTypes.func.isRequired,
};
